import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import quoteSupportActions from './quote-support-actions'

/*

Simply provide quote supporting endpoint configuration to nessessary components. Quote support endpoints
relate to save and exit, restore, payment, ie. the common routes.

*/

const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    quoteSupport: state.quoteSupport
})


const mapDispatchToProps = (dispatch, props) => ({
    actions:{
        ...props.actions,
        quoteSupport: bindActionCreators( quoteSupportActions, dispatch )
    }
})


export const withQuoteSupport = (Wrapped:React.ComponentClass) => connect(mapStateToProps, mapDispatchToProps)(Wrapped)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/quote-support/index.tsx